import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthRoutes from './features/auth/routes';
import LayoutAppRoutes from './features/layout/routes';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import FullscreenLoader from './components/ui/fullscreen-loader';

const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<FullscreenLoader />}>
      <ThemeProvider>
        <LanguageProvider>
          <Routes>
            <Route path="/app/*" element={<LayoutAppRoutes />} />
            <Route path="/*" element={<AuthRoutes />} />
          </Routes>
        </LanguageProvider>
      </ThemeProvider>
    </Suspense>
  );
};

export default AppRoutes;